import { Box } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import { useFlag } from '@unleash/proxy-client-react';
import { FeatureToggle } from 'utils/unleash/toggles';

import { useCareMatrix } from 'hooks/useCareMatrix';
import { getCareMatrixModuleUserData } from 'services/user';

import { RenderBigNumbersSessions } from './components/RenderBigNumbersSessions';
import { RenderCreditInfo } from './components/RenderCreditInfo';
import { RenderHeader } from './components/RenderHeader';
import { RenderSubscriptionInfo } from './components/RenderSubscriptionInfo';
import { useSubscriptionStatus } from './hooks/useSubscriptionStatus';
import { useUserInfo } from './hooks/useUserInfo';

import * as S from './styles';

function BigNumbers() {
  const { patientCognitoId } = useCareMatrix();
  const patientSubscriptionStatusActive = useFlag(
    FeatureToggle.PatientSubscriptionStatus,
  );

  const { isSubscriptionModel } = useUserInfo({
    patientCognitoId,
  });

  const { subscriptionStatus, isLoading: isSubscriptionLoading } =
    useSubscriptionStatus({
      patientCognitoId,
      isSubscriptionModel,
    });

  const {
    data: user,
    isError,
    isLoading: isUserDataLoading,
  } = useQuery({
    queryKey: ['getCareMatrixModuleUserData', patientCognitoId],
    queryFn: () => getCareMatrixModuleUserData(patientCognitoId),
  });

  if (isError) {
    return <Box />;
  }

  return (
    <S.Container>
      <RenderHeader
        linkSource={user?.link.link_source}
        previousType={user?.link.previous_type}
        companyName={user?.company_name}
        userExpirationDate={user?.user_expiration_date}
        linkCreatedAt={user?.link_created_at || ''}
        isLoading={isUserDataLoading}
      />
      <S.Body>
        <RenderBigNumbersSessions
          completedSessions={user?.sessions.completed}
          completedSessionsWithMe={user?.sessions.completed_with_me}
          isLoading={isUserDataLoading}
        />
        <S.StyledDivider orientation="vertical" />
        {isSubscriptionModel && patientSubscriptionStatusActive ? (
          <RenderSubscriptionInfo
            statusSchema={subscriptionStatus.statusSchema}
            expiredAt={subscriptionStatus.expiredAt}
            patientSubscriptionLoading={isSubscriptionLoading}
          />
        ) : (
          <RenderCreditInfo
            remaining={user?.sessions?.remaining}
            isLoading={isUserDataLoading}
          />
        )}
      </S.Body>
    </S.Container>
  );
}
export default BigNumbers;
